define('modules/news/news_view',[
  'backbone',
  'jquery',
  '_',
  'URIjs/URI',
  './news_collection',

  'modules/list/list_view',
  'modules/loading/loading_spinner_view',
  'modules/pagination/pagination_view',
  'modules/order_table/order_table',

  'text!./news_template.html',
  'text!./news_header_template.html',
  'text!./news_list_item_template.html',
  'session',
], function (
  Backbone,
  $,
  _,
  URI,
  newsCollection,
  ListView,
  Loading,
  PaginationView,
  orderTable,
  news_template,
  news_header_template,
  news_list_item_template,
  session
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.pagination = false;
      this.collection = false;
      this.subViews = [];

      this.render();

      var loading = new Loading();
      this.subViews.push(loading);

      this.collection = newsCollection;

      this.listenTo(this.collection, 'request', loading.start.bind(loading));

      this.listenTo(
        this.collection,
        'destroy',
        function (collection) {
          loading.done();
        },
        this
      );

      this.listenTo(
        this.collection,
        'sync',
        function (collection) {
          loading.done();
          this.renderHeader();
          this.renderList();
          this.renderPagination();
        },
        this
      );

      this.collection.params = _.extend(
        this.collection.params,
        URI.parseQuery(this.params)
      );

      this.collection.fetch();
    },

    hasSidebar: false,
    subViews: [],

    template: _.template(news_template),
    header_template: _.template(news_header_template),
    item_template: _.template(news_list_item_template),

    events: {
      'click .news-header-item [data-order-by]': 'orderTableHandler',
    },

    orderTableHandler: function (e) {
      e.preventDefault();
      orderTable($(e.currentTarget), this.collection);
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderHeader: function () {
      var params = _.extend(this.collection.params, {
        with_zone: this.with_zone,
      });
      this.$('.js-news-header').html(this.header_template(params));
      return this;
    },

    renderList: function () {
      var items = [],
        newsList;

      this.collection.each(function (model) {
        items.push({
          model: model,
          value: this.item_template(model.toJSON()),
        });
      }, this);
      newsList = new ListView({
        items: items,
        className: 'list news-list',
      });

      this.$('.js-news-list').html(newsList.$el);

      this.subViews.push(newsList);

      return this;
    },

    renderPagination: function () {
      if (this.pagination) {
        this.pagination.remove();
      }

      this.pagination = new PaginationView(this.collection);
      this.subViews.push(this.pagination);

      this.$el.append(this.pagination.$el);
      this.pagination.delegateEvents();
    },

    setDefaultOrder: function () {
      this.defaultOrder = {
        order_by: 'pinned',
        order: 'DESC',
      };
      this.collection.params = _.extend(
        this.collection.params,
        this.defaultOrder
      );
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.setDefaultOrder();
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

